import { render, staticRenderFns } from "./DonateDates.vue?vue&type=template&id=455feb6a&"
import script from "./DonateDates.vue?vue&type=script&lang=js&"
export * from "./DonateDates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports